module.exports = __webpack_public_path__ + "static/media/ir.158ab671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ir.png
// module id = 1886
// module chunks = 0